import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_PETITION_PAGE_TOP_SUPPORTERS = createFcmConfig('petition_page_top_supporters', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
